module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "page"
  }, [_c('h3', [_vm._v("Какую проблему решает этот сайт?")]), _vm._v("\n\n  Здесь собраны все семинары, митапы и классные события,\n  которые происходят на мехмате. Всегда можно заглянуть и найти что-нибудь интересное.\n\n\n  "), _c('h3', [_vm._v("Как можно подписаться?")]), _vm._v("\n\n  Пока что у нас есть канал в телеграмме\n  "), _c('a', {
    attrs: {
      "href": "https://t.me/mmcs_meetups"
    }
  }, [_vm._v("@mmcs_meetups")]), _vm._v(",\n  новости в нём появляются при анонсе мероприятия и повторно за 4 часа.\n  Скоро сделаем твиттер-аккаунт и паблик вконтакте.\n\n\n  "), _c('h3', [_vm._v("Как добавить событие?")]), _vm._v("\n\n  На данный момент доступ к админке имеют только\n  "), _c('u', {
    attrs: {
      "title": "организаторы мероприятий"
    }
  }, [_vm._v("доверенные")]), _vm._v(" лица.\n  Можно написать на почту (контакты ниже), и мы сами опубликуем мероприятие.\n\n\n  "), _c('h3', [_vm._v("Могу я помочь проекту?")]), _vm._v(" "), _c('p', [_vm._v("Конечно! Расскажи о сайте своим друзьям, студентам или преподавателям.\n\n  ")]), _vm._m(0), _c('h3', {
    staticStyle: {
      "margin-top": "2.5em"
    }
  }, [_vm._v("Контакты")]), _vm._v(" "), _vm._l((_vm.contacts), function(p, i) {
    return _c('p', [_vm._v("\n    " + _vm._s(p.name) + " — " + _vm._s(p.about) + " \n\n    "), _c('span', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_c('a', {
      attrs: {
        "href": p.vk
      }
    }, [_vm._v("vk")]), _vm._v(" /\n      "), _c('a', {
      attrs: {
        "href": _vm.emails[i].href,
        "onclick": _vm.emails[i].click
      }
    }, [_vm._v("email")])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Программируешь? Попробуй написать бота для twitter или vk,\n  нарисовать классную статистику на "), _c('em', [_vm._v("d3.js")]), _vm._v(", или решить проблему\n  из "), _c('a', {
    attrs: {
      "href": "https://github.com/xamgore/mmcs-meetups/issues"
    }
  }, [_vm._v("списка в репозитории")]), _vm._v(".\n\n  Если сомневаешься в своих способностях, не переживай, мы поможем.\n\n\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-59abb411"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/about.vue
// module id = 158
// module chunks = 1